import React from "react";
import { FiUsers, FiTag, FiMic, FiBarChart2, FiTruck, FiLayers } from "react-icons/fi";
import AppLaunchTeaser from "./appLaunchTeaser";

const points = [
  { title: "No vendor hunting", description: "Create the event and we assign reliable, pre-vetted partners for decor, food, photography, and entertainment — you don't chase anyone individually." },
  { title: "One point of contact", description: "A single coordinator handles every partner on your event, so you're never relaying messages between five different vendors." },
  { title: "Built for how families and teams celebrate", description: "Package options that scale from an intimate home gathering to a hall full of guests, priced per person rather than one-size-fits-all." },
  { title: "Accountability end to end", description: "If a partner falls short, that's on Nirkana to fix — not on you to manage on the day of the event." },
];

const roadmap = [
  { title: "More event types", description: "Baby showers, weddings, corporate events, and life's other milestones — the same platform, purpose-built for each.", Icon: FiLayers },
  { title: "Ticketing & registration", description: "Sell tickets and manage registrations directly through Nirkana for public and invite-only events.", Icon: FiTag },
  { title: "Speakers & sponsors", description: "Tools for managing speaker line-ups and sponsor packages on larger events.", Icon: FiMic },
  { title: "Attendee management", description: "Check-ins, guest lists, and communication tools for events of any size.", Icon: FiUsers },
  { title: "Event analytics", description: "Attendance, spend, and partner performance data to help you plan better next time.", Icon: FiBarChart2 },
  { title: "Vendor app", description: "A dedicated app for our service partners to manage bookings, availability, and payouts.", Icon: FiTruck },
];

const About = () => {
  return (
    <>
      <section className="bg-paper py-16 lg:py-24">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <div className="max-w-prose">
            <h2 className="text-3xl font-bold text-brand sm:text-4xl">Why Nirkana</h2>
            <p className="mt-4 text-muted">
              We're building an event-planning platform meant to cover
              every kind of gathering. Phase one is focused entirely on
              birthdays — doing one event type properly before we expand.
            </p>
          </div>

          <div className="mt-14 grid grid-cols-1 gap-x-10 gap-y-10 md:grid-cols-2">
            {points.map((point) => (
              <div key={point.title} className="border-t border-line pt-6">
                <h3 className="text-lg font-semibold text-charcoal">{point.title}</h3>
                <p className="mt-2 text-sm text-muted">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-brand py-16 lg:py-24">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <div className="max-w-prose">
            <span className="inline-flex items-center rounded-full bg-paper/10 px-3 py-1 text-xs font-semibold text-gold">
              Roadmap
            </span>
            <h2 className="mt-4 text-3xl font-bold text-paper sm:text-4xl">Where we're headed</h2>
            <p className="mt-4 text-paper/70">
              Birthdays are phase one. Here's what we're building next as
              the platform grows to cover the full life of an event —
              and eventually, every kind of event.
            </p>
          </div>

          <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {roadmap.map(({ title, description, Icon }) => (
              <div key={title} className="rounded-xl border border-paper/15 p-6">
                <Icon className="text-gold" size={22} />
                <h3 className="mt-4 text-base font-semibold text-paper">{title}</h3>
                <p className="mt-2 text-sm text-paper/70">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <AppLaunchTeaser />
    </>
  );
};

export default About;
